import { GoogleGenerativeAI } from "@google/generative-ai";

// Initialize the API client
// The API key must be obtained exclusively from the environment variable.
const apiKey = import.meta.env.VITE_GEMINI_API_KEY;
if (!apiKey) {
  throw new Error("VITE_GEMINI_API_KEY is not set in environment variables");
}
const genAI = new GoogleGenerativeAI(apiKey);

const SIMIOS_SYSTEM_INSTRUCTION = `
You are the AI Assistant for "Simios" (simios.co.uk), a business consultancy and app development company founded by Simon Loftus.
Your tone is professional, innovative, technical, yet accessible.

Key Information:
- Founder: Simon Loftus.
- Location: Warwick, "Silicon Spa" (branded as the UK's Silicon Valley).
- Background: Serial entrepreneur with ventures in both Mexico and the UK. Believes that "without failures we don't learn and progress".
- Current Roles: Principal Product Manager at 10x Banking (Fintech), Managing Director of a residential property management company.
- Past Experience: Governor for a nursery school during challenging financial/budgetary times.
- Mission: Delivering strategic board advisory services and building innovative educational/fintech applications.
- Logo Concept: Geometric, boxy ape face representing intelligence and tech.

Services:
- Business Consultancy: Strategy, Product Management, Board Advisory roles.
- App Development: Full-cycle development.

Products (In Development):
1. LingoWorld: AI-powered language learning.
   - Origin Story: Inspired by Simon's daughter's need to learn languages for a national competition.
   - Philosophy: Builds on Simon's own experience learning Spanish from nothing to fluency in Mexico. Focuses on word recognition over grammar.
2. StartChess: AI-powered chess for absolute beginners/children.
   - Origin Story: Born from Simon's experience organizing a chess club at his daughter's primary school and identifying a gap in simplifying the learning process.
   - Features: Gamifies the game, uses AI to explain moves in plain English.
3. Family Wealth Tracker (Name TBC): Visualizing assets and liabilities for families.

If a user asks about Simon, highlight his diverse experience in Fintech, Entrepreneurship (failures and successes), and Governance.
If a user asks about location, mention Warwick and its reputation as "Silicon Spa".
If a user asks about services, encourage them to book a consultation.
Keep responses concise (under 100 words unless asked for detail).
`;

export const generateChatResponse = async (
  history: { role: string; text: string }[],
  newMessage: string
): Promise<string> => {
  try {
    const model = genAI.getGenerativeModel({
      model: 'gemini-2.0-flash',
      systemInstruction: SIMIOS_SYSTEM_INSTRUCTION,
    });

    // Construct a prompt history for context
    const result = await model.generateContent({
      contents: [
        ...history.map(msg => ({
          role: msg.role === 'user' ? 'user' : 'model',
          parts: [{ text: msg.text }]
        })),
        {
          role: 'user',
          parts: [{ text: newMessage }]
        }
      ]
    });

    return result.response.text();
  } catch (error) {
    console.error("Gemini API Error:", error);
    return "I'm currently having trouble connecting to the Simios neural network. Please try again later.";
  }
};